import Cookie from 'js-cookie';

class Fetch {
    #getHeaders() {
        return {
            'X-CSRFToken': Cookie.get('csrftoken'),
        };
    }

    #fetch(url, method, data, abortController) {
        let ok = false;
        let signal = (abortController) ? abortController.signal : null;
        let headers = this.#getHeaders();

        switch (method) {
            case 'POST': case 'PUT': case 'PATCH': case 'DELETE':
                headers = {...headers, 'Content-Type': 'application/json'}
        }


        return fetch(url, {
            method: method,
            signal: signal,
            headers: headers,
            body: (data) ? JSON.stringify(data) : null,
        }).then((response) => {
            ok = response.ok;
            return response.text()
        }).then((text) => {
            return (text.length > 0) ? JSON.parse(text) : null;
        }).then((data) => ({ok: ok, data: data}));
    }

    get(url, abortController) {
        return this.#fetch(url, 'GET', null, abortController);
    }
    post(url, data, abortController) {
        return this.#fetch(url, 'POST', data, abortController);
    }
    put(url, data, abortController) {
        return this.#fetch(url, 'PUT', data, abortController);
    }
    patch(url, data, abortController) {
        return this.#fetch(url, 'PATCH', data, abortController);
    }
    delete(url, data, abortController) {
        return this.#fetch(url, 'DELETE', data, abortController);
    }
}

export default Fetch;
